import { render, staticRenderFns } from "./marketData.vue?vue&type=template&id=74906a29&scoped=true"
import script from "./marketData.vue?vue&type=script&lang=js"
export * from "./marketData.vue?vue&type=script&lang=js"
import style0 from "./marketData.vue?vue&type=style&index=0&id=74906a29&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74906a29",
  null
  
)

export default component.exports